import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import "./Shutdown.css";

class ShutdownBase extends React.Component {
    render() {
        return (
          <MDBRow className='align-items-center countdown-row' style={{ position: "fixed", height: "100%", width: "100%", margin: "0px", padding: "0px", textAlign: "center" }}>
            <MDBCol>
                <h2 style={{ fontWeight: 400 }} className="shutdown-h2">
                    Unfortunately, track.easterbunny.cc will not run in 2026.
                </h2>
                <h4 style={{ fontWeight: 400 }}>
                    Please read the news page for further information.
                </h4>
            </MDBCol>
          </MDBRow>
        )
    }
}

export default ShutdownBase